<template>
  <v-data-table
    :headers="headers"
    :items="info"
    :loading="loading_state"
    :rows-per-page-items="rowsPerPageItems"
    :rows-per-page-text="labels.rows_per_page"
    :no-data-text="labels.no_data"
  >
    <template slot="items" slot-scope="props">
      <td style="padding: 0px 5px;">{{ props.item.CourseNo }}</td>
      <td style="padding: 0px 5px;">{{ props.item.Dimension }}</td>
      <td
        style="padding: 0px 5px;"
        v-on:mouseover="getCourseClasses(props.item)"
      >
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{ props.item.CourseName }}</span>
          </template>
          <div>
            <strong>{{ labels.enable_class }}</strong>
            <br />
            <span v-for="(item, index) in course_classes" :key="index">
              {{ item }}
              <br />
            </span>
          </div>
        </v-tooltip>
      </td>
      <td style="padding: 0px 5px;">{{ props.item.CreditPoint }}</td>
      <td style="padding: 0px 5px;">{{ props.item.RequireOption }}</td>
      <td style="padding: 0px 5px;">{{ props.item.AllYear }}</td>
      <td style="padding: 0px 5px;">{{ props.item.CourseTeacher }}</td>
      <td style="padding: 0px 5px;">{{ props.item.OpenClass }}</td>
      <td style="word-break: break-all; width: 20px; padding: 0px 5px;">
        {{ props.item.Node }}
      </td>
      <td style="padding: 0px 5px;">{{ props.item.ClassRoomNo }}</td>
      <td style="padding: 0px 5px;">{{ props.item.Contents }}</td>
    </template>
  </v-data-table>
</template>

<script>
import languages from "../../languages/Table.json";

export default {
  data: () => ({
    labels: {
      rows_per_page: "",
      no_data: "",
      enable_class: "",
      select: "",
    },
    headers: [],
    rowsPerPageItems: [50, 100, { text: "All", value: -1 }],
  }),
  computed: {
    newest_semester() {
      return this.$store.state.semesters[0]["Semester"];
    },
    info() {
      return this.$store.state.info;
    },
    course_classes() {
      return this.$store.state.course_classes;
    },
    loading_state() {
      return this.$store.state.loading_state;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    select_language() {
      return this.$store.state.select_language;
    },
  },
  watch: {
    isLogin(value) {
      if (value) {
        this.headers.push({
          text: this.labels.select,
          width: "3%",
          align: "center",
          sortable: false,
        });
      } else {
        this.headers.pop();
      }
    },
    select_language(value) {
      this.setLanguage(value);
    },
  },
  created() {
    if (this.$store.state.isLogin) {
      this.headers.push({
        text: this.labels.select,
        width: "3%",
        align: "center",
        sortable: false,
      });
    }
    this.setLanguage(this.$store.state.select_language);
  },
  methods: {
    showDeital: function(course_no) {
      this.$store.dispatch("queryDetial", {courseNo:course_no, Semester:""});
    },
    getCourseClasses: function(select_course) {
      this.$store.dispatch("getCourseClasses", select_course);
    },
    setLanguage: function(select_language) {
      this.labels.rows_per_page = languages.rows_per_page[select_language.lang];
      this.labels.no_data = languages.no_data[select_language.lang];
      this.labels.enable_class = languages.enable_class[select_language.lang];
      this.labels.select = languages.select[select_language.lang];

      this.headers = [
        {
          text: languages.course_code[select_language.lang],
          width: "7%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.ge_type[select_language.lang],
          width: "3%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.course_title[select_language.lang],
          width: "10%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.credits[select_language.lang],
          width: "3%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.require_option[select_language.lang],
          width: "3%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.full_half[select_language.lang],
          width: "3%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.instructor[select_language.lang],
          width: "7%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.open_class[select_language.lang],
          width: "7%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.day_time[select_language.lang],
          width: "13%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.location[select_language.lang],
          width: "7%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.notes[select_language.lang],
          width: "25%",
          align: "center",
          sortable: false,
        },
      ];

      this.rowsPerPageItems = [
        50,
        100,
        { text: languages.all[select_language.lang], value: -1 },
      ];
    },
  },
};
</script>
